export default "__VITE_ASSET__D1rS2pHN__"